<template>
    <spinner v-if="isLoading"></spinner>
    <transition name="fade">
        <div>
            <BreadCrumbs
                :breadCrumbs="breadCrumbs"
                :title="title"
                :back_title="back_title"
                :link="link"
            />
            <div class="d-flex flex-column justify-content-center mt-0">
                <div class="mt-2 mb-2 text-center">
                    <router-link class="btn btn-red btn_vw" to="/request/memos/index">
                        {{ $t("request.my_memos") }}
                    </router-link>
                </div>
                <div class="mt-2 mb-2 text-center" v-if="chiefMemos > 0">
                    <router-link class="btn btn-red btn_vw" to="/request/memos/chief/list">
                        {{ $t("request.waiting") }}
                        <span class="badge rounded-pill text-bg-white ms-2">{{ chiefMemos }}</span>
                    </router-link>
                </div>
                <div class="mt-2 mb-2 text-center" v-if="contains(actions, 'prosmotr-zurnala-sluzebki')">
                    <router-link class="btn btn-red btn_vw" to="/request/memos/journal">
                        {{ $t("request.journal") }}
                    </router-link>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import spinner from "../../../components/Spinner";
import BreadCrumbs from "../../../Page/BreadCrumbs";
import Modules from "../../../Page/Modules";
import axios from "axios";
import {getUserPermissionActions} from "../../../services/helpers";

export default {
    name: "MemosPage",
    components: {
        spinner, BreadCrumbs, Modules
    },
    data() {
        return {
            actions: [],
            chiefMemos: 0,
            isLoading: false,
            breadCrumbs: true,
            title: this.$t('request.memos'),
            back_title: this.$t('request.request_menu'),
            link: 'request',
        }
    },
    created() {
        this.getData();
        this.getUserActions();
        this.eventBus.emit('page-width', '1180px');
    },
    methods: {
        async getUserActions(){
            this.isLoading = true;
            this.actions = await getUserPermissionActions(this.$route.path);
            this.isLoading = false;
        },
        contains(arr, elem){
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].alias === elem) {
                    return true;
                }
            }
            return false;
        },
        async getData(){
            try {
                this.isLoading = true;
                const config = {'headers': { 'Authorization': 'Bearer ' + this.$cookie.getCookie('token') }};
                const response = await axios.get('/api/admin/memos/waiting', config);
                this.chiefMemos = response.data.data.requestCount;
            } catch (e) {
                console.log(e);
            }finally {
                this.isLoading = false;
            }
        },
    }
}
</script>

<style scoped>

</style>
